export const CATEGORY_RENAMED = 'settings/CATEGORY_RENAMED';
export const categoryRenamed = () => ({
  type: CATEGORY_RENAMED,
});
